import { Flex } from "antd";
import styled from "styled-components";

export const AVATAR_SIZE = 64;

export const StaffMemberContainer = styled(Flex)(({ theme }) => ({
  maxWidth: 72,
  gap: theme.spacing,
  alignItems: "center",
}));

export const StaffMemberImage = styled("img")({
  borderRadius: "50%",
  width: AVATAR_SIZE,
  height: AVATAR_SIZE,
});
